export default "__VITE_ASSET__Dvp1frZt__"